/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { loaderViewNew as LoaderViewNew } from '../../shared/loaderViewNew';
import Pagination from '../../common/pagination/globalPaginationComponent';
import '../../css/viewGenAIView.css';

export const viewGenAIView = (props) => {
  const {
    showRequirement,
    parsedRequirement,
    selectedRecord,
    onRecordSelect,
    onEditClicked,
    onAddClicked,
    isLoading,
    totalRecords,
    currentPage,
    pageLimit,
    getLeftPanelTitle,
    selectedProvider,
    selectedModel,
    handleChangellm,
    llmModels
  } = props;
  const TestCheck = sessionStorage.getItem('TestCheck');
  if (isLoading) {
    return <LoaderViewNew />;
  }
  return (
    <div className="page--superAdmin">
      <div className="superAdmin__container">
        <div className="mb-3 row">
          <h3 className="heading heading__level2 col-8">
            {/* {TestCheck === 'TestData'
              ? 'View Test Data'
              : 'View Test Cases'} */}
          </h3>
          <div className="col-2 d-flex justify-content-end">
            {/* <select
                  value={`${selectedProvider}|${selectedModel}`}
                  onChange={(eve) => handleChangellm(eve)}
                  className='form-select'
                >
                  {Object.entries(llmModels).map(([provider, models]) => (
                    <optgroup key={provider} label={provider.toUpperCase()}>
                      {Object.entries(models).map(([key, label]) => (
                        <option key={key} value={`${provider}|${key}`}>
                          {label}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select> */}
          </div>
          <div className="col-2 text-right d-flex justify-content-end">
            <button
              className="btn btn-prime mb-2"
              onClick={() => onAddClicked()}
            >
              Create New
              <i className="fa fa-plus mx-2"></i>
            </button>
          </div>
          <hr />
        </div>
        {showRequirement && (
          <>
            <div className="viewgenai-master">
              {/* LEFT PANEL */}
              { selectedRecord ? (
                <>
                <div className="viewgenai-left">
                {parsedRequirement?.map((item, index) => (
                  <div
                    key={item.id || index}
                    className={
                      selectedRecord?.id === item.id
                        ? 'left-card active'
                        : 'left-card'
                    }
                    onClick={() => onRecordSelect(item)}
                  >
                    <div className="left-title">
                      {/* <span className="left-title-badge">{index + 1}</span>{' '} */}
                      {props.getLeftPanelTitle(item)}
                    </div>
                  </div>
                ))}
              </div>
              {/* RIGHT PANEL */}
              <div className="viewgenai-right">
                {selectedRecord && (
                  <>
                    <div className="detail-header">
                      <h4> {selectedRecord.tcName}</h4>
                      <button
                        className="btn btn-prime"
                        onClick={(e) =>
                          onEditClicked(e, selectedRecord)
                        }
                      >
                        Edit
                        <i className="fa fa-pencil mx-2" />
                      </button>
                    </div>
                    <table className="table table-bordered detail-table">
                      <tbody>
                        <tr>
                          <th width="20%">Jira ID</th>
                          <td>{selectedRecord.jiraId || '--'}</td>
                        </tr>
                        <tr>
                          <th>Requirement</th>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  selectedRecord.requirement || ''
                              }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Business Rules</th>
                          <td>
                            {selectedRecord.businessRules ? (
                              selectedRecord.businessRules
                                .split('\n')
                                .map((rule, index) => (<div key={index}>• {rule}</div>))
                            ) : ('--')}
                          </td>
                        </tr>
                        <tr>
                          <th>Test Scenario</th>
                          <td>
                            {selectedRecord.htmlTcScenario ? (
                              <div
                                className="scenario-html"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    selectedRecord.htmlTcScenario
                                }}
                              />
                            ) : (
                              <pre className="plain-json">
                                {selectedRecord.tcScenario}
                              </pre>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Automation Code</th>
                          <td>
                            {selectedRecord.tcCode ? (
                              <pre
                                dangerouslySetInnerHTML={{
                                  __html:
                                    selectedRecord.tcCode
                                }}
                              />
                            ) : ( '--')}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}
              </div> </>) : (
                  <div className="no-record">
                    <div className="empty-state">
                      <div className="empty-icon">
                        <i className="fa fa-flask" />
                      </div>

                      <h3>
                        {TestCheck === 'TestData'
                          ? 'No Test Data Available'
                          : 'No Test Cases Available'}
                      </h3>

                      <p>
                        {TestCheck === 'TestData'
                          ? 'Generate your first test data using the "Create New" button. Your latest generated records will appear in the left panel, and selecting one will display its details here.'
                          : 'Generate your first test case using the "Create New" button. Your latest generated records will appear in the left panel, and selecting one will display its details here.'}
                      </p>
                    </div>
                  </div>
                )}
            </div>
            <Pagination
              data={parsedRequirement}
              totalRecords={totalRecords}
              currentPage={currentPage}
              pageLimit={pageLimit}
              changeData={(e, currentPage, pageLimit) =>
                props.changeData(e, currentPage, pageLimit)
              }
            />
          </>
        )}
      </div>
    </div>
  );
};